<div class="modal-header">
    <h3 class="modal-title">{{ 'MODELPROPERTIES' | translate }}</h3>
</div>
<form novalidate name="modelpropsform" id="modelpropsform">
    <div class="modal-body modelprops">
        @if (aanhef) {
            <p class="dl-model-props__aanhef">{{ aanhef }} :</p>
        }
        <div class="mb-3">
            <label class="form-label fw-bold" for="modelnaam">{{ 'MODELNAAM' | translate }}:</label>
            <input class="form-control"
                   id="modelnaam"
                   type="text"
                   [(ngModel)]="model.titel"
                   name="titel"
                   [disabled]="titelDisabled"
                   required
                   pattern="[\u0020-\u0FFF]+"
                   minlength="3"
                   maxlength="90">
        </div>

        <div class="mb-3">
            <label class="form-label fw-bold" for="modelleerniveauselect">{{ 'MODELLEERNIVEAU' | translate }}:</label>
            <div class="dl-ulselect"
                 [class.dl-ulselect--open]="selectOpen"
                 id="modelleerniveauselect"
                 (click)="toggleNiveauselect($event)">
                <div class="dl-ulselect__waarde form-select" [class.disabled]="!modelleerniveauSchrijfbaar">
                    {{ huidigNiveau.naam }}
                    @for (icon of huidigNiveau.icons; track icon) {
                        <img alt="" [src]="'resources/img/' + icon" class="dl-ulselect__icoon">
                    }
                    @for (letter of huidigNiveau.letters; track letter) {
                        <div class="dl-ulselect__icoon">{{ letter }}</div>
                    }
                </div>
                <ul class="dl-ulselect__lijst">
                    @for (niveau of niveaus; track niveau.val) {
                        <li class="dl-ulselect__item"
                            (click)="niveauselectClick(niveau, $event)"
                            [class.disabled]="niveau.disabled">
                            {{ niveau.naam }}
                            @for (icon of niveau.icons; track icon) {
                                <img alt="" [src]="'resources/img/' + icon" class="dl-ulselect__icoon">
                            }
                            @for (letter of niveau.letters; track letter) {
                                <div class="dl-ulselect__icoon">{{ letter }}</div>
                            }
                        </li>
                    }
                </ul>
            </div>
        </div>

        <div class="mb-3">
            <label class="form-label fw-bold" for="simulatiepreferentie">{{ 'SIMULATIEPREFERENTIES' | translate }}:</label>
            <select id="simulatiepreferentie"
                    class="form-select"
                    name="simulatiepreferentie"
                    [(ngModel)]="model.simulatiepreferentie"
                    [disabled]="!simulatiepreferentieSchrijfbaar">
                <option [ngValue]="0">{{ 'ALS_PROJECT' | translate }} ({{ projectSimulatiepreferentie }})</option>
                <option disabled>--------------</option>
                <option [ngValue]="100">{{ 'SIMULATIEPREFERENTIE_100' | translate }}</option>
                <option [ngValue]="120">{{ 'SIMULATIEPREFERENTIE_120' | translate }}</option>
                <option [ngValue]="130">{{ 'SIMULATIEPREFERENTIE_130' | translate }}</option>
                <option [ngValue]="140">{{ 'SIMULATIEPREFERENTIE_140' | translate }}</option>
                <option disabled>--------------</option>
                <option [ngValue]="160">{{ 'SIMULATIEPREFERENTIE_160' | translate }}</option>
                <option [ngValue]="170">{{ 'SIMULATIEPREFERENTIE_170' | translate }}</option>
                <option [ngValue]="180">{{ 'SIMULATIEPREFERENTIE_180' | translate }}</option>
                <option [ngValue]="200">{{ 'SIMULATIEPREFERENTIE_200' | translate }}</option>
                <option disabled>--------------</option>
                <option [ngValue]="230">{{ 'SIMULATIEPREFERENTIE_230' | translate }}</option>
                <option [ngValue]="240">{{ 'SIMULATIEPREFERENTIE_240' | translate }}</option>
                <option [ngValue]="250">{{ 'SIMULATIEPREFERENTIE_250' | translate }}</option>
                <option [ngValue]="300">{{ 'SIMULATIEPREFERENTIE_300' | translate }}</option>
            </select>
        </div>

        <div class="mb-3">
            <label class="form-label fw-bold" for="fastestpath">{{ 'FASTESTPATH.LABEL' | translate }}:</label>
            <select id="fastestpath"
                    class="form-select"
                    name="fastestpath"
                    [(ngModel)]="model.fastest_path"
                    [disabled]="!fastestPathOverschrijfbaar">
                <option [ngValue]="null">{{ 'ALS_PROJECT' | translate }} ({{ projectFastestPath }})</option>
                <option disabled>--------------</option>
                <option [ngValue]="true">{{ 'FASTESTPATH.AAN' | translate }}</option>
                <option [ngValue]="false">{{ 'FASTESTPATH.UIT' | translate }}</option>
            </select>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-info" (click)="bevestig()" [disabled]="!formulierGeldig">
            {{ 'BTN_SAVE' | translate }}
        </button>
        <button class="btn btn-secondary" (click)="annuleer()">
            {{ 'BTN_CANCEL' | translate }}
        </button>
    </div>
</form>
